import { AuthStep } from '@/bundle/Auth/ui/AuthStep/AuthStep';
import { Box } from '@/components/Box/Box';
import SuccessSecondaryIcon from '@/images/SuccessSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { COLORS } from '@/styles/colors';
import { mainConfig } from '@/config/envConfig';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';

type SignUpSuccessWidgetType = {
  email: string;
};

export const SignUpSuccessWidget = ({ email = '' }: SignUpSuccessWidgetType) => {
  return (
    <>
      <AuthStep>
        <Box display='flex' flexDirection='column' alignItems='center' rowGap='20px'>
          <SuccessSecondaryIcon />
          <Box display='flex' flexDirection='column' rowGap='14px'>
            <Box display='flex' flexDirection='column' rowGap='12px'>
              <Typography variant='headline4' fontWeight='semibold' textAlign='center'>
                Thank you for your request
              </Typography>
              <Typography color={COLORS.black} textAlign='center'>
                We’ve sent an email to{' '}
                <Typography as='span' color={COLORS.green[500]}>
                  {email}
                </Typography>{' '}
                with the next steps. Please check your inbox and click the link to continue setting up your WireVault
                account.
              </Typography>
            </Box>
            <Box display='flex' flexDirection='column' rowGap='4px'>
              <Typography variant='subTitleSmall' color={COLORS.black} fontWeight='medium' textAlign='center'>
                Didn’t receive the email?
              </Typography>
              <Typography color={COLORS.grey[650]} textAlign='center'>
                Make sure to check your spam or junk folder.
                <br />
                Still nothing? Please{' '}
                <NavigationLink to={`${mainConfig.LANDING_URL}?contactUs=true`} size='large' target='_blank'>
                  contact us
                </NavigationLink>
                .
              </Typography>
            </Box>
          </Box>
        </Box>
      </AuthStep>

      <Box margin='32px 16px 24px'>
        <NavigationLink to={getLoginPath()}>{'< Return to Login'}</NavigationLink>
      </Box>
    </>
  );
};
